import cn from 'classnames';
import React from 'react';

import styles from './styles.css';
import { type PopupLearnMoreCloseProps } from './types';

export const PopupLearnMoreClose = ({
  onClose,
  className,
}: PopupLearnMoreCloseProps) => {
  return (
    <div
      onClick={onClose}
      className={cn(styles.close, className)}
      data-test="widget-close"
    />
  );
};
